import {
  EMPTY_OBJECT,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import { ListItem } from '../../ListItem'
import { EmailAccountWidgetItemContent } from '../EmailAccountWidgetItemContent'

import * as styles from './EmailAccountWidgetItem.module.css'

import EmailIcon from '../../../icons/email.svg'

function EmailAccountWidgetItem({
  className = styles.EmailAccountWidgetItem,
  contentContainerProps: {
    className: contentContainerClassName = styles.contentContainer,
    ...contentContainerProps
  } = EMPTY_OBJECT,
  hoverClassName = styles.hover,
  ...restProps
}) {
  return (
    <ListItem
      {...restProps}
      Content={EmailAccountWidgetItemContent}
      ListIcon={EmailIcon}
      className={className}
      contentContainerProps={{
        ...contentContainerProps,
        className: contentContainerClassName,
      }}
      hoverClassName={hoverClassName}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
    />
  )
}

export default EmailAccountWidgetItem
